import React, { useState, useEffect } from "react";
import axios from "axios";
import Reject from "../../../../../assets/images/Icon/Rejected.png";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import AllModuleData from "../../../../Reuseable/AllModuleData";
import LoaderPost from "../../../../Reuseable/LoaderPost";

const RejectedLearningSession = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/learning_session/rejected`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Rejected Learning Session"
        image={Reject}
        count={count}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar-admin/learning-session/pending`}
        />
      )}
    </>
  );
};

export default RejectedLearningSession;
